import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { formatDateTime } from "../../../util/formatsForDate";
import { createPortal } from "react-dom";

const EditAddItemForPurchase_archive = ({showModal, handleColse, row, getDataTable }) => {
      const GET_Edit = `admin/setting/paying_customer/transaction/${row?.id}`
    console.log(row)
    const [formData, setFormData] = useState({
 
        invoiceNumber: row?.invoice,
        receiptNumber: row?.transactionId,
        notes: row?.note,
    });
    // const [formData, setFormData] = useState({
    //     date: row?.date || "",
    //     time: row?.time || "",
    //     product: row?.productId || null,
    //     quantity: row?.quantity || "",
    //     totalPrice: row?.totalPrice || 0,
    //     invoiceNumber: row?.invoiceNumber || "",
    //     receiptNumber: row?.transactionId || "",
    //     notes: row?.note || "",
    //   });
    // const [products, setProducts] = useState([]);
    const [error, setError] = useState("");

 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };



    const handleSubmit = (e) => {
        // e.preventDefault();
        // if (!formData.date || !formData.time || !formData.product || !formData.quantity) {
        //     setError("יש למלא את כל השדות החובה");
        //     return;
        // }
        // setError("");
        addNewPurchase(formData);
    };


    const addNewPurchase = async () => {
        const response = await axios.put(GET_Edit, JSON.stringify({
           
            "transactionIdNew": formData?.receiptNumber,
            "invoiceNew": formData?.invoiceNumber,
            "note": formData?.notes
                   }), {
            headers: { 'Content-Type': 'application/json' }
        })
 
        if (response?.status == 200) {
            
            alert("הטופס נערך בהצלחה!");
            await getDataTable()
            handleColse()
        }
        else {
            alert("נשכל");
        }
    }

    useEffect(() => {
        const container = document.getElementById('purchase_archive');
        if (!container) return;
    
        if (showModal) {
            container.style.overflow = 'hidden'; // Disable scroll on the container
        } else {
            container.style.overflow = 'auto'; // Re-enable scroll
        }
    
        return () => {
            container.style.overflow = 'auto'; // Cleanup on unmount
        };
    }, [showModal]);
    return (
        createPortal(
        <div className='fixed top-0 min-h-screen z-20 left-0 flex flex-col items-center pt-2 w-full drop-shadow-2xl shadow-2xl bg-[#FDFFFC]/50 '
            onClick={() => {
                // handleColse()
            }}>
            <div className='bg-white w-2/5 rounded-lg divide-y-2  divide-slate-500 border-0 border-emerald-50 '>
                <div className='w-full bg-[#0d406b] rounded-t-md flex justify-end border-[#0d406b] border-2'>
                    <button className='p-1 px-2 m-3 border bg-slate-500 hover:bg-slate-200' onClick={() => {
                        handleColse()
                    }} >x</button>
                </div>
                <div className="w-full  flex flex-col items-center ">
                <form className='max-md:w-[500px] w-full  m-[30px auto]  flex flex-col  ' style={{ direction: "rtl" }} >
               
                    
                    
                    <div className="flex w-full items-center p-2 gap-2">
                    <label className="w-1/4 text-center">מספר חשבונית</label>
                    <input className="w-2/3 border rounded p-2" type="text" name="invoiceNumber" value={formData.invoiceNumber} onChange={handleChange}  />
                    </div>
                   
                    <div className="flex w-full items-center p-2 gap-2">
                    <label className="w-1/4 text-center">מספר קבלה</label>
                    <input className="w-2/3 border p-2 rounded" type="text" name="receiptNumber" value={formData.receiptNumber} onChange={handleChange}  />
                    </div>


                    <div className="flex items-center p-2 gap-2">
                        <label className="w-1/4 text-center">הערות</label>
                        <textarea className="w-2/3 min-h-20 p-2 border  rounded" name="notes" value={formData.notes} onChange={handleChange} ></textarea>
                    </div>
                    {error && <p className="text-red-500">{error}</p>}





                </form >
                </div>
                <div className='w-full p-2   flex justify-end'>
                    <button className='border bg-green-500 hover:bg-green-300 p-1 px-3' onClick={() => {
                      
                        handleSubmit()


                    }}>שמור</button>
                    <button className='border bg-slate-700 hover:bg-slate-500 p-1 px-3' onClick={() => {
                        // reset()
                        // setShowModal(false)
                        handleColse()
                    }}>בטל</button>
                </div>
            </div >
        </div >,document.getElementById('modalllll'))
    )
}

export default EditAddItemForPurchase_archive